<template>
  <NodeViewWrapper class="image-loader">
    <div class="spinner"></div>
  </NodeViewWrapper>
</template>

<script>
import { NodeViewWrapper } from '@tiptap/vue-3'

export default {
  components: {
    NodeViewWrapper,
  },
}
</script>

<style scoped>
.image-loader {
  width: 100%;
  padding: 40px 0;
  display: flex;
  justify-content: center;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 4px solid rgba(0,0,0,.15);
  border-top-color: rgba(0,0,0,.6);
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
